import { Textarea } from '@chakra-ui/react';
import React from 'react';
import { Link } from 'react-router-dom';
import { useEffect, useState } from 'react';

export const TextBox = () => {
  const [memo, setMemo] = useState(() => localStorage.getItem('memo') || '');

  useEffect(() => {
    localStorage.setItem('memo', memo);
  }, [memo]);

  return (
    <Textarea
      margin={3}
      width={350}
      placeholder="メモを入力してください"
      value={memo}
      onChange={(e) => setMemo(e.target.value)}
    />
  );
};
